import { IAttribute, IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { LinkedServiceUtils } from './linked-service.utils';
import { driverVersions } from 'app/registries/consts/tabular-consts';

@Metamodel.model({
    name: adfModelTypeMap.vertica.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Vertica_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Vertica_DisplayText)
    ]
})
export class VerticaLinkedService extends LinkedService {

    public static readonly MODEL: IModel;
    public static readonly SERVER: IAttribute;
    public static readonly PORT: IAttribute;
    public static readonly DATABASE: IAttribute;
    public static readonly USERNAME: IAttribute;
    public static readonly PASSWORD: IAttribute;
    public static readonly REFERED_AKV: IAttribute;

    @Metamodel.attribute({
        display: stringResources.VersionLabel
    })
    public version?: string = driverVersions.v2;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServerName,
        association: 'SERVER',
        templatable: true
    })
    public server?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Port,
        association: 'PORT',
        templatable: true
    })
    public port?: number = 5433;

    @Metamodel.attribute({
        display: stringResources.ModelName_DatabaseName,
        association: 'DATABASE',
        templatable: true
    })
    public databaseName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName,
        association: 'USERNAME',
        templatable: true
    })
    public userName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        association: 'PASSWORD',
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        templatable: true,
        accepts: ['String']
    })
    public password?: string | AzureKeyVault;

    public enableAKV?: boolean = false;
    @Metamodel.attribute({
        association: 'REFERED_AKV',
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public referedAKV?: AzureKeyVault;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public convertV1toV2(context: { inlineDataset?: boolean }): VerticaLinkedService {
        const copy = LinkedServiceUtils.commonV1ToV2(context, this) as VerticaLinkedService;
        if (this.enableAKV) {
            copy.enableAKV = false;
            delete copy.referedAKV;
        }
        return copy;
    }
}
